import { RowSelectionState } from '@tanstack/react-table';
import { EntityResolved } from '@toggle/toggle';

import { useOnboardingStore } from '~/views/onboarding/hooks/useOnboardingStore';

export const useEntityChangeHandlers = (
  setRowSelection: React.Dispatch<React.SetStateAction<RowSelectionState>>
) => {
  const { setEntitiesList, setUnMappedEntitiesList } = useOnboardingStore(
    state => ({
      setEntitiesList: state.setEntitiesList,
      setUnMappedEntitiesList: state.setUnMappedEntitiesList,
    })
  );

  const onChangeEntity = (
    prevEntity: EntityResolved,
    newEntity: EntityResolved
  ) => {
    setRowSelection(prev => {
      const { [prevEntity.tag]: _removed, ...rest } = prev;
      return { ...rest, [newEntity.tag]: true };
    });

    const updatedList = useOnboardingStore
      .getState()
      .entitiesList.map(e => (e.tag === prevEntity.tag ? newEntity : e));
    const uniqByTag = new Map<string, EntityResolved>();
    updatedList.forEach(e => uniqByTag.set(e.tag, e));
    setEntitiesList(Array.from(uniqByTag.values()));
  };

  const onAddEntity = (entity: EntityResolved) => {
    setRowSelection(prev => ({ ...prev, [entity.tag]: true }));
    setEntitiesList([...useOnboardingStore.getState().entitiesList, entity]);
    setUnMappedEntitiesList([
      ...useOnboardingStore
        .getState()
        .unMappedEntitiesList.filter(e => e.input !== entity.input),
    ]);
  };

  const onRemoveEntity = (entity: EntityResolved) => {
    setRowSelection(prev => {
      const { [entity.tag]: _removed, ...rest } = prev;
      return rest;
    });
    setEntitiesList(
      useOnboardingStore
        .getState()
        .entitiesList.filter(e => e.tag !== entity.tag)
    );
    setUnMappedEntitiesList([
      ...useOnboardingStore.getState().unMappedEntitiesList,
      { input: entity.input },
    ]);
  };

  return {
    onChangeEntity,
    onAddEntity,
    onRemoveEntity,
  };
};
